
export const environment = {
  production: true,
  apiUrl: 'https://in2padel-backend.the-alpha.co/api',
  // apiUrl: 'http://in2padel.local/api',

  googleMapsKey: 'AIzaSyAVTUb5_R-zL6FSa31G18-sknD38Gh7WxY',

  payment: {
    publicKey: 'pk_test_3bgiVz6P0deHJkpOZl1SL5Qy',
    merchantId: '65007036',
  },
};
